export const cabecalhos = [
  {
    text: 'Status Análise',
    value: 'descricao_linha',
    style: {
      width: '40%'
    }
  },
  {
    text: 'data_analise_inicial',
    value: 'valor_data_inicial',
    formatar_valor: true,
    style: {
      width: '15%'
    }
  },
  {
    text: 'data_analise_final',
    value: 'valor_data_final',
    formatar_valor: true,
    style: {
      width: '15%'
    }
  },
  {
    text: 'Diferença',
    value: 'diferenca_em_valor',
    formatar_valor: true,
    style: {
      width: '15%'
    }
  },
  {
    text: 'Diferença%',
    value: 'diferenca_em_porcentagem',
    formatar_valor: true,
    style: {
      width: '15%'
    }
  },
];
